// audience-analytics.service.ts
import { Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AudienceAnalyticsService {
  constructor(
    private analyticsService: AnalyticsService,
    private platform: Platform
  ) {}

  /**
   * Track app installation/add to home screen
   */
  trackInstallation(): Promise<any> {
    return this.analyticsService.logEvent('TRUE_pwa_install', {
      platform: this.getPlatform(),
      device_model: this.getDeviceModel()
    });
  }

  /**
   * Track user demographic information (ensure GDPR compliance)
   */
  trackUserDemographic(gender?: string, language?: string, location?: string): Promise<any> {
    // Set as user properties for segmentation
    const properties: {[key: string]: string} = {};

    if (gender) properties['gender'] = gender;
    if (language) properties['language'] = language;
    if (location) properties['location'] = location;

    return this.analyticsService.setUserProperties(properties);
  }

  /**
   * Track session start
   */
  trackSessionStart(): Promise<any> {
    return this.analyticsService.logEvent('session_start', {
      timestamp: new Date().toISOString()
    });
  }

  /**
   * Track screen view
   */
  trackScreenView(screenName: string, screenClass: string): Promise<any> {
    return this.analyticsService.logEvent('screen_view', {
      screen_name: screenName,
      screen_class: screenClass
    });
  }

  /**
   * Helper methods for platform/device detection
   */
  private getPlatform(): string {
    if (this.platform.is('ios')) {
      return 'iOS';
    } else if (this.platform.is('android')) {
      return 'Android';
    } else {
      return 'Web';
    }
  }

  private getDeviceModel(): string {
    // Simplified implementation
    if (this.platform.is('ios')) {
      return 'iOS Device';
    } else if (this.platform.is('android')) {
      return 'Android Device';
    } else {
      return 'Web Browser';
    }
  }
}
